// source: type/order_receive_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.OrderReceiveKind', null, global);
goog.exportSymbol('proto.type.OrderReceiveType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.OrderReceiveType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveType.displayName = 'proto.type.OrderReceiveType';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveType.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveType.toObject = function(includeInstance, msg) {
  var f, obj = {
    kind: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of OrderReceiveType as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveType.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.kind;

  /** @type {?|undefined} */
  this.name;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveType.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveType}
 */
proto.type.OrderReceiveType.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveType();
  obj.kind != null && jspb.Message.setField(msg, 1, obj.kind);
  obj.name != null && jspb.Message.setField(msg, 2, obj.name);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveType}
 */
proto.type.OrderReceiveType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveType;
  return proto.type.OrderReceiveType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveType}
 */
proto.type.OrderReceiveType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.type.OrderReceiveKind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional OrderReceiveKind kind = 1;
 * @return {!proto.type.OrderReceiveKind}
 */
proto.type.OrderReceiveType.prototype.getKind = function() {
  return /** @type {!proto.type.OrderReceiveKind} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.type.OrderReceiveKind} value
 * @return {!proto.type.OrderReceiveType} returns this
 */
proto.type.OrderReceiveType.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.type.OrderReceiveType.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.OrderReceiveType} returns this
 */
proto.type.OrderReceiveType.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.type.OrderReceiveKind = {
  DELIVERY: 0,
  PICKUP_SHOP: 1,
  PICKUP_CAR: 2,
  NONE_RECEIVE_TYPE: 3,
  PICKUP_LOCKER: 4,
  PICKUP_OTHER_SHOP: 5,
  DELIVERY_UNATTENDED: 6,
  DELIVERY_CONTACTLESS: 7
};

goog.object.extend(exports, proto.type);
